import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import { Tagline } from "@/components/pro-blocks/landing-page/tagline"
import { SupportTicketDemo } from "@/components/feedbackiq/support-ticket-demo"

export function HeroSection2() {
  return (
    <section className="bg-secondary section-padding-y" aria-labelledby="hero-heading">
      <div className="container-padding-x container mx-auto flex flex-col gap-12 lg:gap-16">
        {/* Top: Text content */}
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 text-center lg:gap-8">
          <Tagline>FeedbackIQ</Tagline>
          <h1 id="hero-heading" className="heading-xl text-balance">
            Хватит тонуть в обращениях клиентов
          </h1>
          <p className="text-muted-foreground max-w-2xl text-base lg:text-lg">
            Пока вы вручную читаете 80 писем из 300, критически важные проблемы остаются незамеченными. FeedbackIQ
            анализирует 100% обращений и показывает, что действительно важно.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col gap-3 sm:flex-row">
            <Button size="lg">Попробовать бесплатно</Button>
            <Button variant="ghost" size="lg">
              Как это работает
              <ArrowRight className="ml-1 h-4 w-4" />
            </Button>
          </div>
          <p className="text-muted-foreground text-sm">Подключение за 5 минут. Карта не требуется.</p>
        </div>

        {/* Bottom: Interactive demo */}
        <SupportTicketDemo />
      </div>
    </section>
  )
}
